export default "assets/images/property-mask-78e668f2.svg";